module.exports = __webpack_public_path__ + "img/logo_jpg.e4d13ec3.png";